import styles from "./Success.module.scss";

const JobAlertsContextualSuccessBg = () => (
    <>
        <svg className={styles.planeTop} viewBox="0 0 319 62" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M 51.26 45.02 C 53.2 42.43 9.11 39.65 9.11 13.26 C 9.11 -6.02 17.42 -16.45 37.53 -25 C 47.13 -29.08
                59.04 -27.59 97.94 -9.44 C 146.56 13.26 179.63 59.29 238.63 38.54 C 285.83 21.94 310.6 -10.73
                317.08 -25"
                stroke="#9ADBF5"
                strokeWidth="2.27"
                strokeDasharray="2.27 2.27"
            />
            <path
                d="M 30.62 52.65 L 77.5 59.29 L 46.39 38.23 L 44.81 44.99 L 33.41 47.04 L 30.62 52.65 Z"
                fill="#9AA9E6"
            />
            <path
                d="M 77.5 59.29 L 38.49 39.32 L 0.25 37.41 L 77.5 59.29 Z M 44.95 38.23 L 76.06 59.29 L 51.97 26.38 L
                44.95 38.23 Z"
                fill="#9ADBF5"
            />
        </svg>
        <svg className={styles.planeBottom} viewBox="0 0 381 55" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M 360.83 13.49 C 358.2 17 417.82 20.76 417.82 56.45 C 417.82 82.51 406.58 96.61 379.4 108.17 C 366.41
                113.69 350.31 111.68 297.71 87.13 C 231.96 56.45 187.25 -5.8 107.48 22.26 C 43.65 44.7 10.17 88.88 1.4
                108.17"
                stroke="#9ADBF5"
                strokeWidth="3"
                strokeDasharray="3.07 3.07"
            />
            <path
                d="M 334.78 31.07 L 280.71 38.73 L 316.59 14.44 L 318.41 22.23 L 331.56 24.59 L 334.78 31.07 Z"
                fill="#9AA9E6"
            />
            <path
                d="M 280.71 38.73 L 325.7 15.69 L 369.8 13.49 L 280.71 38.73 Z M 318.26 14.44 L 282.38 38.73 L 310.15
                0.77 L 318.26 14.44 Z"
                fill="#9ADBF5"
            />
        </svg>
    </>
);

JobAlertsContextualSuccessBg.displayName = "JobAlertsContextualSuccessBg";

export { JobAlertsContextualSuccessBg as default };
